import { Component } from '@angular/core';

@Component({
  selector: 'app-record-type-info-modal',
  templateUrl: './record-type-info-modal.component.html',
  standalone: false
})
export class RecordTypeInfoModalComponent {

}
